import { ownProfileEditRedirect } from '@/components/profile/ownProfileEditRedirect';

export default ownProfileEditRedirect('about');
